import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import {
  getNorthbeamUtmPlatformParams,
  NorthbeamUtmPlatform,
} from "@features/utm-guide";

export function Revcontent() {
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform: NorthbeamUtmPlatform.REVCONTENT,
  });
  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        For each of the following parameter pairs, input them into{" "}
        <b>Revcontent</b> for each campaign in the <b>UTM tracking</b> section.
        For more information, you can look at <b>Revcontent</b>&apos;s{" "}
        <GenericExternalLink href="https://help.revcontent.com/knowledge/campaign-tracking-variables">
          documentation
        </GenericExternalLink>
        .
      </p>
      <table className="table table-bordered table-striped table-sm bg-white">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {urlParamPairs.map(({ key, value }) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
